exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card_content[data-v-dc38a5b8]{margin:1em 0;cursor:pointer;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:-webkit-box;display:-ms-flexbox;display:flex}.card_content .icon[data-v-dc38a5b8]{width:auto;height:90px;margin:-1em 0 0 -1em}.card_content .content .text[data-v-dc38a5b8]{font-size:12px;text-align:left;text-justify:inter-word;text-transform:capitalize}.card_content .content .title[data-v-dc38a5b8]{color:#0080fc;font-family:Muli;font-weight:700}.card_content .content .description[data-v-dc38a5b8]{color:#000;font-family:Lato;font-weight:500}.line[data-v-dc38a5b8]{background-color:#7070703d;height:1px;width:98%;opacity:.6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dc38a5b8","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/dashboard-v5/tutorial/components/CardTutorial.vue
// module id = e0J4
// module chunks = 0